window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

export default gtag;



// WEBPACK FOOTER //
// ./src/gtag.js